module.exports = __webpack_public_path__ + "img/van.38d5db91.jpeg";